import { render } from "./NullComponent.vue?vue&type=template&id=a2688584"
import script from "./NullComponent.vue?vue&type=script&lang=js"
export * from "./NullComponent.vue?vue&type=script&lang=js"

import "./NullComponent.vue?vue&type=style&index=0&id=a2688584&lang=scss"

import exportComponent from "C:\\Users\\chbo\\Documents\\repos\\semco-maritime-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__